/**
 * Interpretacao do erro de `POST /api/v1/auth/change-password`.
 *
 * Compartilhado por `ChangePassword.tsx` (tela avulsa) e
 * `SetupWizardStepPassword.tsx` (passo 1 do wizard) — os dois tinham o mesmo
 * bloco de `if/else` duplicado, e os dois traduziam
 * `password_change_not_required` como "tente novamente".
 *
 * Esse detail NAO e erro: o backend (`api.py`, guarda de
 * `must_change_password`/`temp_password_hash`) usa 400 para dizer que a senha JA
 * foi trocada. Tratar como erro prende o usuario num formulario que nunca vai
 * aceitar — foi o que aconteceu em 21/08/2026, com 12 tentativas seguidas.
 */

export type ResultadoTrocaSenha =
  /** A senha ja esta trocada. Seguir o mesmo caminho do sucesso. */
  | { tipo: 'ja_trocada' }
  | { tipo: 'erro'; mensagem: string }

const MENSAGEM_GENERICA = 'Erro ao trocar a senha. Tente novamente.'

/**
 * O diretorio de identidade recusou a senha digitada.
 *
 * Nao dizer "tente novamente": repetir a MESMA senha falha sempre. Entre
 * 25/08 e 31/08/2026 o backend devolvia 502 nesse caso, a tela mandava esperar
 * alguns minutos, e tres usuarios em primeiro acesso somaram 17 tentativas
 * seguindo essa instrucao — rogerio.porto sozinho tentou 11 vezes em 10
 * minutos. Nos tres, o sucesso veio segundos depois, com outra senha.
 *
 * A mensagem nao afirma o motivo da recusa (a badlist e a hipotese principal,
 * nao um fato medido) — ela diz a acao que resolveu em 3 de 3.
 */
export const MENSAGEM_SENHA_RECUSADA =
  'Esta senha não foi aceita — ela pode estar numa lista de senhas comuns. ' +
  'Escolha outra, sem palavras óbvias nem partes do seu nome.'

export function interpretarErroDeTrocaDeSenha(detail: unknown): ResultadoTrocaSenha {
  const d = typeof detail === 'string' ? detail : ''

  if (d === 'password_change_not_required') return { tipo: 'ja_trocada' }
  if (d === 'invalid_current_password') {
    return { tipo: 'erro', mensagem: 'Senha atual incorreta.' }
  }
  if (d === 'password_rejected_by_directory') return { tipo: 'erro', mensagem: MENSAGEM_SENHA_RECUSADA }
  if (d.startsWith('kanidm_provisioning_failed')) {
    return {
      tipo: 'erro',
      mensagem: 'Erro ao configurar credenciais. Tente novamente em alguns minutos.',
    }
  }
  if (d === 'password_too_short') {
    return { tipo: 'erro', mensagem: 'A nova senha deve ter no mínimo 10 caracteres.' }
  }
  return { tipo: 'erro', mensagem: MENSAGEM_GENERICA }
}
